export default "__VITE_ASSET__C2LDTOj9__ 640w, __VITE_ASSET__DplAlNKx__ 1024w, __VITE_ASSET__CvMA9sW5__ 1536w";